'use strict';

var React = require('react');

var SvgMarketsEuroFilledIcon = function SvgMarketsEuroFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 3a7 7 0 1 0 2.554 13.52 4.74 4.74 0 0 1-.911-1.27 5.5 5.5 0 0 1-1.643.25 5.477 5.477 0 0 1-2.53-.616l.488-.488a1.917 1.917 0 0 1 2.372-.27c.295.184.633.282.977.285l-.007-.022a2.25 2.25 0 0 1 0-4.278c.093-.303.207-.59.342-.86l-.017-.001h-.507c-.78 0-1.493.44-1.842 1.138l-.122.246a1.115 1.115 0 0 1-2.098-.316l-.058-.353a1.537 1.537 0 0 1 1.03-1.71l.75-.25c.58-.194.972-.738.972-1.35a.92.92 0 0 1 .543-.84l1.904-.859a5.521 5.521 0 0 1 2.328 1.916 4.206 4.206 0 0 1 1.707-.064 7 7 0 0 0-6.232-3.808Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.843 11.25c.185-.904.615-1.372 1.009-1.58a1.468 1.468 0 0 1 1.651.194.75.75 0 0 0 .994-1.124 2.968 2.968 0 0 0-3.349-.395c-.94.499-1.614 1.488-1.827 2.905h-.321a1 1 0 1 0 0 2h.321c.213 1.417.886 2.406 1.828 2.905a2.969 2.969 0 0 0 3.348-.395.75.75 0 0 0-.994-1.124 1.468 1.468 0 0 1-1.652.194c-.393-.208-.823-.676-1.008-1.58h2.157a1 1 0 1 0 0-2h-2.157Z"
  }));
};
SvgMarketsEuroFilledIcon.displayName = "MarketsEuroFilledIcon";

exports.SvgMarketsEuroFilledIcon = SvgMarketsEuroFilledIcon;
